<template>
  <div class="download-root">
    <div class="download-card">
      <h2 class="download-title">插件下载</h2>
      <button class="main-btn" @click="onDownloadClick">下载插件「聚宝铺」</button>
      <p class="tip">如遇无法下载，请联系客服获取安装包</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { checkVersion } from '../api/admin'

async function onDownloadClick() {
  try {
    const res = await checkVersion('0.0.0')
    if (res.code === 200 && res.data && res.data.downPath) {
      window.location.href = res.data.downPath
    } else {
      alert(res.message || '获取下载链接失败')
    }
  } catch (e) {
    alert('网络错误，获取下载链接失败')
  }
}

onMounted(() => {
  document.title = '聚宝铺-插件下载'
})
</script>

<style scoped>
.download-root {
  min-height: 100vh;
  background: #f7faff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 0;
}
.download-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px #4ba3fa22;
  padding: 48px 40px 36px 40px;
  max-width: 420px;
  width: 100%;
  color: #222;
  text-align: center;
}
.download-title {
  color: #2979ff;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 2px;
}
.main-btn {
  background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 1.08rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px #4ba3fa33;
  transition: background 0.2s;
}
.main-btn:hover {
  background: linear-gradient(90deg, #2979ff 0%, #4ba3fa 100%);
}
.tip {
  color: #2979ff;
  font-size: 0.98rem;
  text-align: center;
  margin-top: 18px;
}
@media (max-width: 600px) {
  .download-card {
    padding: 24px 8px;
    border-radius: 12px;
  }
}
</style> 